import React from 'react';

const UploadingState = ({ progress, fileName }) => {
	const pct = Math.max(0, Math.min(100, Math.round(progress)));
	return (
		<div className="image-upload-control__uploading" aria-live="polite">
			<div className="image-upload-control__uploading-row">
				<div className="image-upload-control__uploading-tile" aria-hidden="true">
					<span className="image-upload-control__uploading-spinner" />
				</div>
				<div style={{ flex: 1, minWidth: 0 }}>
					<div className="image-upload-control__uploading-name">{fileName || 'logo'}</div>
					<div className="image-upload-control__uploading-status">Uploading… {pct}%</div>
				</div>
				<span className="image-upload-control__uploading-pct">{pct}%</span>
			</div>
			<div
				className="image-upload-control__uploading-bar"
				role="progressbar"
				aria-valuenow={pct}
				aria-valuemin={0}
				aria-valuemax={100}
				aria-label="Upload progress"
			>
				<div style={{ width: `${pct}%` }} />
			</div>
		</div>
	);
};

export default UploadingState;
